<template>
  <div class="activities-preview">
    <div v-for="item in $$FormData.activities" :key="item.goods_id" class="activity-item">
      <img :src="item.thumbnail" class="activity-cover" alt=""/>
      <div class="activity-info">
        <div class="activity-title ellipsis-2">
          {{ item.goods_name }}
        </div>
        <div class="btn-view">
          <div class="gg-btn solid">立即报名</div>
        </div>
      </div>
    </div>
    <div v-if="!$$FormData.activities.length" class="empty">
      请选择活动
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivitiesPreview'
}
</script>

<style lang="scss" scoped>
.activities-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}
.activity-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: calc(100% - 16px);
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px 13px 10px 20px;
  border-radius: 10px;
  background-color: #ffffff;
  .activity-cover {
    width: 91px;
    height: 101px;
    border-radius: 5px;
    flex-shrink: 0;
  }
  .activity-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 101px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .activity-title {
    color: #3C4353;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    padding-right: 5px;
  }
  .btn-view {
    display: flex;
    justify-content: flex-end;
    .gg-btn {
      width: 70px;
      height: 18px;
      font-size: 12px;
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  width: 100%;
  height: 75px;
}
</style>
